import { GetterTree } from 'vuex';
import { ILookupResult } from '../shared-types';
import { IFundSearchState } from './types';

const getters: GetterTree<IFundSearchState, any> = {
  lookup(state): string {
    return state.lookup;
  },
  businessCode(state): string {
    return state.businessCode;
  },
  numberOfFetching(state): number {
    return state.numberOfFetching;
  },
  results(state): ILookupResult[] {
    return state.results;
  },
  accessToken(state): string {
    return state.accessToken;
  },
  fundSearchApiEndpoint(state): string {
    return state.fundSearchApiEndpoint;
  },
  selectedResultIndex(state): number {
    return state.selectedResultIndex;
  },
  selectedResult(state): ILookupResult | null {
    return state.results[state.selectedResultIndex];
  },
  cacheSuffix(state): string {
    return state.cacheSuffix;
  },
  mustHaveCacheSuffix(state): boolean {
    return state.mustHaveCacheSuffix;
  },
  lastFetchError(state): string | null {
    return state.lastFetchError;
  },
};

export default getters;
